import { RefObject, useEffect, useRef } from 'react';
import { useOverlayScrollbars } from 'overlayscrollbars-react';
import {
  CUSTOM_SCROLLBAR_INITIALIZATION_ATTRIBUTE,
  DEFAULT_SCROLLBAR_PARAMS,
} from '../../../../services';
import { mergeSX } from '../../../../services/helpers';
import Panel, { IPanelProps } from '../../../Panel';

export interface IScrollablePanelProps extends IPanelProps {}

const SCROLLABLE_PANEL_SX = {
  height: '100%',
};

const ScrollablePanel = (props: IScrollablePanelProps) => {
  const { sx, ...restProps } = props;

  const ref = useRef<HTMLDivElement>();
  const [initialize] = useOverlayScrollbars(DEFAULT_SCROLLBAR_PARAMS);

  useEffect(() => {
    initialize(ref.current as HTMLDivElement);
  }, [initialize]);

  return (
    <Panel
      {...CUSTOM_SCROLLBAR_INITIALIZATION_ATTRIBUTE}
      sx={mergeSX(SCROLLABLE_PANEL_SX, sx)}
      ref={ref as RefObject<HTMLDivElement>}
      {...restProps}
    />
  );
};

export default ScrollablePanel;
